import { authActions as auth } from 'src/store/auth/auth.actions';
import { profileActions } from '../profile/profile.actions';

const initialState = {
  login: {
    isFetching: false,
    loggedIn: false,
    errorcodes: [],
    error: false,
    notAuthorizedForRequest: false,
  },
  logout: {
    isFetching: false,
    errorcodes: [],
    // logged out/in state is handled by the presence of the logged-in cookie from js-cookie
    error: false,
  },
  sendForgotPasswordEmail: {
    isFetching: false,
    success: false,
  },
  changePassword: {
    isFetching: false,
    success: false,
    error: false,
    errorcodes: [],
  },
  resetPassword: {
    isFetching: false,
    success: false,
    error: false,
    errorcodes: [],
  },

  confirmationOfProfileInformation: {
    needToConfirm: false,
    isFetching: false,
    error: false,
  },
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
  case 'RESET_STORE':
    return initialState;
  case auth.login().type:
    return {
      ...state,
      login: {
        ...state.login,
        isFetching: true,
        loggedIn: false,
        error: false,
        errorcodes: [],
      },
    };
  case auth.loginSuccess().type:
    return {
      ...state,
      login: {
        ...state.login,
        isFetching: false,
        loggedIn: true,
        error: false,
        errorcodes: [],
      },
    };
  case profileActions.fetchSuccess().type:
    return {
      ...state,
      login: {
        ...state.login,
        loggedIn: true,
      },
    };
  case auth.loginFailure().type:
    return {
      ...state,
      login: {
        ...state.login,
        isFetching: false,
        loggedIn: false,
        error: true,
        errorcodes: action.payload.errorcodes,
      },
    };
  case auth.logout().type:
    return {
      ...state,
      logout: {
        ...state.logout,
        isFetching: true,
        error: false,
        errorcodes: [],
      },
    };
  case auth.logoutSuccess().type:
    return {
      ...state,
      login: {
        ...state.login,
        loggedIn: false,
      },
      logout: {
        ...state.logout,
        isFetching: false,
        error: false,
        errorcodes: [],
      },
    };
  case auth.logoutFailure().type:
    return {
      ...state,
      login: {
        ...state.login,
        loggedIn: false,
      },
      logout: {
        ...state.logout,
        isFetching: false,
        error: true,
        errorcodes: action.payload.errorcodes,
      },
    };
  case auth.sendForgotPasswordEmail().type:
    return {
      ...state,
      sendForgotPasswordEmail: {
        ...state.sendForgotPasswordEmail,
        isFetching: true,
        success: false,
        error: false,
      },
    };
  case auth.sendForgotPasswordEmailSuccess().type:
    return {
      ...state,
      sendForgotPasswordEmail: {
        ...state.sendForgotPasswordEmail,
        isFetching: false,
        error: false,
        success: true,
      },
    };
  case auth.sendForgotPasswordEmailFailure().type:
    return {
      ...state,
      sendForgotPasswordEmail: {
        ...state.sendForgotPasswordEmail,
        error: true,
        errorcodes: action.payload.errorcodes,
        success: false,
        isFetching: false,
      },
    };
  case auth.changePassword().type:
    return {
      ...state,
      changePassword: {
        ...state.changePassword,
        isFetching: true,
        success: false,
        error: false,
        errorcodes: [],
      },
    };
  case auth.changePasswordSuccess().type:
    return {
      ...state,
      changePassword: {
        ...state.changePassword,
        isFetching: false,
        success: true,
        error: false,
        errorcodes: [],
      },
    };
  case auth.changePasswordFailure().type:
    return {
      ...state,
      changePassword: {
        ...state.changePassword,
        isFetching: false,
        success: false,
        error: true,
        errorcodes: [],
      },
    };

  case auth.userNeedsToConfirmProfileInformation().type:
    return {
      ...state,
      confirmationOfProfileInformation: {
        ...state.confirmationOfProfileInformation,
        needToConfirm: true,
      },
    };
  case auth.userConfirmedProfileInformation().type:
    return {
      ...state,
      confirmationOfProfileInformation: {
        ...state.confirmationOfProfileInformation,
        needToConfirm: true,
        error: false,
        isFetching: true,
      },
    };
  case auth.userConfirmedProfileInformationSuccess().type:
    return {
      ...state,
      confirmationOfProfileInformation: {
        ...state.confirmationOfProfileInformation,
        needToConfirm: false,
        error: false,
        isFetching: false,
      },
    };
  case auth.userConfirmedProfileInformationError().type:
    return {
      ...state,
      confirmationOfProfileInformation: {
        ...state.confirmationOfProfileInformation,
        needToConfirm: false,
        error: true,
        isFetching: false,
      },
    };

  default:
    return state;
  }
};

export default authReducer;
